// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.block[data-v-3e16bcd6] {\n  padding: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
